import React, { useMemo } from 'react';
import ServerError from '../../../../../components/ServerError';
import { SkeletonTable } from '../../../components/Skeleton/Table';
import { useEmployeeTargetProfileQuery } from '../../../__generated__/graphql';
import { Employee } from '..';
import { mapTargetProfileRows, sortTargetProfileRows } from './logic';
import { TargetProfileCard } from './TargetProfileCard';

type Props = {
  employee: Employee;
};

export const EmployeeTargetProfile: React.FC<
  React.PropsWithChildren<Props>
> = ({ employee }) => {
  const { data, loading, error } = useEmployeeTargetProfileQuery({
    variables: { employeeId: employee.Id },
  });

  const rows = useMemo(() => {
    const employee = data?.manager.employee;
    return employee
      ? sortTargetProfileRows(
          mapTargetProfileRows(
            employee.positionRequiredSkills,
            employee.employeeSkills,
          ),
        )
      : null;
  }, [data]);

  // Layout (width, position) is owned by the parent Skills tab so this card can
  // sit beside the skills chart.
  if (error) {
    return <ServerError />;
  }
  if (loading || !rows) {
    return <SkeletonTable columns={3} rows={4} />;
  }
  return <TargetProfileCard rows={rows} />;
};

export { TargetProfileCard } from './TargetProfileCard';
export type { TargetProfileRow } from './logic';
